package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
data class AccountSerialNumberInfo(
    val serialNumber: String
)

@Serializable
@JsExport
data class AccountSerialNumberResponse(
    val serialNumber: String? = null,
    val model: String? = null,
    val name: String? = null,
    val externalId: String? = null,
    val images: List<AccountImages> = emptyList(),
)

@Serializable
@JsExport
data class AccountImages(
    val tag: String,
    val url: String,
)